import { Circle } from '../types/Circle.ts';
import { RelativePosition } from './RelativePosition';
import { RelativeRadius } from './RelativeRadius';

export class FilledCircle implements Circle {
    constructor(
        private ctx: CanvasRenderingContext2D,
        private position: RelativePosition,
        private radius: RelativeRadius,
        private color: string
    ) {}

    draw(): void {
        this.ctx.beginPath();
        this.ctx.fillStyle = this.color;
        this.ctx.arc(this.position.position().x, this.position.position().y, this.radius.radius(), 0, Math.PI * 2);
        this.ctx.fill();
    }
} 